import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { KambiSportName } from '@mobi/api-types/kambi/sports'
import { KambiGroup } from '@mobi/api-types/kambi'

const sportsRootInitialState: SportsRootState = {
  favouriteSports: [],
  favouriteMarkets: {},
  favouriteCompetitions: [],
}

const sportsRootSlice = createSlice({
  name: 'sports-root',
  initialState: sportsRootInitialState,
  reducers: {
    toggleSportMarketsFavourite(
      state,
      { payload }: PayloadAction<{ sportName: KambiSportName; marketCriterionName: string }>
    ) {
      let list = state.favouriteMarkets[payload.sportName] || []
      if (list.includes(payload.marketCriterionName)) {
        list = list.filter(item => item !== payload.marketCriterionName)
      } else {
        list.push(payload.marketCriterionName)
      }
      state.favouriteMarkets[payload.sportName] = list
    },

    toggleFavourite(state, { payload }: PayloadAction<Favourite>) {
      switch (payload.eventGroupType) {
        case 'sport':
          if (state.favouriteSports.some(item => item.id === payload.id)) {
            state.favouriteSports = state.favouriteSports.filter(item => item.id !== payload.id)
          } else {
            state.favouriteSports.push(payload)
          }
          break
        case 'competition':
          if (state.favouriteCompetitions.some(item => item.id === payload.id)) {
            state.favouriteCompetitions = state.favouriteCompetitions.filter(
              item => item.id !== payload.id
            )
          } else {
            state.favouriteCompetitions.push(payload)
          }
          break
      }
    },
  },
})

export const { toggleSportMarketsFavourite, toggleFavourite } = sportsRootSlice.actions

export default persistReducer(
  {
    key: 'sports-root',
    storage,
    // debug: !PRODUCTION,
    whitelist: ['favouriteSports', 'favouriteCompetitions'],
  },
  sportsRootSlice.reducer
)

// =====
// Types
// =====

// favouriteMarketCriterionName list for each sport
export type FavouriteKambiMarket = Partial<Record<KambiSportName, string[]>>

type FavouriteBase = Pick<KambiGroup, 'id' | 'name' | 'sport'> & { path: string }
type FavouriteSport = FavouriteBase & { eventGroupType: 'sport' }
type FavouriteCompetition = FavouriteBase & { eventGroupType: 'competition' }
type Favourite = FavouriteSport | FavouriteCompetition

export interface SportsRootState {
  favouriteMarkets: FavouriteKambiMarket
  favouriteSports: FavouriteSport[]
  favouriteCompetitions: Favourite[]
}
